module.exports = __webpack_public_path__ + "img/shop.8d8227ed.svg";